<select
  [formControl]="formControl"
  [compareWith]="props.compareWith ? props.compareWith : defaultOptions.props.compareWith"
  [formlyAttributes]="field"
  class="form-control"
  [ngClass]="props.inputClass"
  [attr.aria-label]="props.ariaLabel | translate"
  [attr.aria-required]="props.required ? 'true' : undefined"
  [attr.aria-invalid]="showError ? 'true' : undefined"
  [attr.aria-describedby]="props.ariaDescribedByIds"
  [attr.data-testing-id]="field.key"
>
  @if (props.options && props.options | formlySelectOptions : field | async; as opts) { @for (opt of opts; track opt) {
  <option [value]="opt.value" [disabled]="opt.disabled">
    {{ opt.label }}
  </option>
  } }
</select>
